// extracted by mini-css-extract-plugin
module.exports = {"table":"MillOptionsSection_table__36jop","sections":"MillOptionsSection_sections__wxHQS"};